// extracted by mini-css-extract-plugin
export var currencyInput = "_mc-1";
export var currencySymbol = "_mc-0";